module.exports = __webpack_public_path__ + "img/device_cover_sol.60d8b196.svg";